import React, { useMemo } from 'react';
import useScreenSize from '../../../../hooks/useScreenSize/useScreenSize';
import { CalendarLanguage } from '../../../../utils/CalendarUtils';
import './CalendarHeader.scss';
const rootClassName = 'calendar-header';

interface calendarHeaderProps {
  language: CalendarLanguage;
}

export default function CalendarHeader(props: calendarHeaderProps) {
  const size = useScreenSize();
  const days = useMemo(() => {
    if (props.language.daysOfWeekAbrev && ['xs', 'sm'].includes(String(size))) {
      return props.language.daysOfWeekAbrev;
    }
    return props.language.daysOfWeek;
  }, [props.language.daysOfWeek, props.language.daysOfWeekAbrev, size]);

  return (
    <div className={rootClassName}>
      {days.map((d, i) => {
        return (
          <div className={`${rootClassName}-day`} key={i}>
            {d}
          </div>
        );
      })}
    </div>
  );
}
